import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import "react-dropzone-uploader/dist/styles.css";
import Dropzone from "react-dropzone-uploader";
import axios from "axios";
import { getapiurl } from "../../api/api";
import LoadingImage from "../loading/image";
import LabelImage from "../cards/image";
import { getAppParams, getAppId } from "../../api/api";

const formatBytes = (bytes, decimals = 2) => {
  if (bytes === 0) return "0 Bytes";

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
};
const Preview = ({ meta }) => {
  const { name, size, previewUrl } = meta;
  return (
    <div className={"dzu-previewContainer"} style={{ display: "block" }}>
      <div className={"dzu-previewStatusContainer"}>
        <img
          className={"dzu-previewImage"}
          src={previewUrl}
          style={{ maxHeight: "100px" }}
          alt={"preview"}
        />
        <p
          style={{
            paddingLeft: "5px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            lineHeight: "1.2",
            width: "65%",
            fontSize: "14px",
          }}
        >
          {name}
        </p>
        <p style={{ paddingLeft: "5px", fontSize: "13px", fontWeight: "500" }}>
          {" "}
          {"Size:" + formatBytes(size)}
        </p>
      </div>
    </div>
  );
};

const MyVerticallyCenteredModal = (props) => {
  const [isLoading, setisLoading] = useState(false);
  const api_url = getapiurl() + "api/aws/uploadImage";
  const save_url = getapiurl() + "api/aws/" + getAppId() + "/saveImage";

  /*  const myApiService = async()=>
 {
  const { url } = await fetch(api_url).then(res => res.json());
  
  
 } */

  /*  const getUploadParams = async ({ file}) => {
    const f = file;
    
    // * GET request: presigned URL
    const response = await axios({
      method: "GET",
      url: api_url
    });

    

    // * PUT request: upload file to S3
    const key= response.data.url.key;
    const fileName =f["name"];
    const result = await fetch(response.data.url.url, {
      method: "PUT",
      headers: {
        "Content-Type": "multipart/form-data"
      },
      body: file,
    });
    
    const body= {
      "name":fileName,
      "key":key
    }
    return {url:save_url,body}
  }  */

  // called every time a file's `status` changes
  const handleChangeStatus = ({ meta, file }, status) => {};

  // receives array of files that are done uploading when submit button is clicked
  const handleSubmit = async (files) => {
    for (var i = 0; i < files.length; i++) {
      setisLoading(true);

      const f = files[i];
      let filename = f["file"]["name"];
      let fileExt = filename.split(".").pop();

      // * GET request: presigned URL
      const response = await axios({
        method: "GET",
        url: api_url + "/" + fileExt,
      });

      // * PUT request: upload file to S3
      const key = response.data.url.key;
      const fileName = f["file"]["name"];

      const result = await fetch(response.data.url.url, {
        method: "PUT",
        headers: {
          "Content-Type": "multipart/form-data",
        },
        body: f["file"],
      });

      // Saving into DB
      const savedData = await axios
        .post(save_url, {
          imageName: fileName,
          imagekey: key,
        })
        .then(
          (response) => {
            return response;
          },
          (error) => {
            return error.response;
          }
        );

      setisLoading(false);
      props.onHide();
      const option = {
        value: key,
        label: (
          <LabelImage url={getAppParams() + key} name={fileName}></LabelImage>
        ),
        key: key,
        name: fileName,
        id: savedData.data._id,
      };
      props.allimage.unshift(option);
    }
  };

  if (isLoading) {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Uploading Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <LoadingImage></LoadingImage>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  } else {
    return (
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Upload Image
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Dropzone
            multiple={false}
            onChangeStatus={handleChangeStatus}
            onSubmit={handleSubmit}
            accept="image/*"
            PreviewComponent={Preview}
            submitButtonContent="Upload and Save"
            styles={{
              dropzone: { height: 300, backgroundColor: "#f7f7f7" },
              dropzoneActive: { borderColor: "green" },
              submitButton: { backgroundColor: "#ee3c2c" },
              inputLabel: { color: "#000" },
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    );
  }
};
export default MyVerticallyCenteredModal;
